import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  delayTime: 0,
  maxDelayTime: 1
};
export var createDelayNodeConstructor = function createDelayNodeConstructor(audioNodeConstructor, createAudioParam, createDelayNodeRenderer, createNativeDelayNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(DelayNode, _audioNodeConstructor);
    var _super = _createSuper(DelayNode);
    function DelayNode(context, options) {
      var _this;
      _classCallCheck(this, DelayNode);
      var nativeContext = getNativeContext(context);
      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
      var nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
      _this = _super.call(this, context, false, nativeDelayNode, delayNodeRenderer);
      _this._delayTime = createAudioParam(_assertThisInitialized(_this), isOffline, nativeDelayNode.delayTime);
      setAudioNodeTailTime(_assertThisInitialized(_this), mergedOptions.maxDelayTime);
      return _this;
    }
    _createClass(DelayNode, [{
      key: "delayTime",
      get: function get() {
        return this._delayTime;
      }
    }]);
    return DelayNode;
  }(audioNodeConstructor);
};